/* ---- Binaery custom calendar core ---- */

(function (global) {
  if (global.BinaeryCalendar) return;

  function pad(n) { return String(n).padStart(2, "0"); }

  function toISO(d) {
    return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
  }

  function isoToDDMMYYYY(iso) {
    if (!iso) return "";
    var p = String(iso).slice(0, 10).split("-");
    if (p.length !== 3) return "";
    return pad(p[2]) + "." + pad(p[1]) + "." + p[0];
  }

  function parseYMD(str) {
    if (!str) return null;
    var p = String(str).slice(0, 10).split("-");
    if (p.length !== 3) return null;
    var y = parseInt(p[0], 10);
    var m = parseInt(p[1], 10) - 1;
    var d = parseInt(p[2], 10);
    if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;
    return new Date(y, m, d);
  }

  function isCartPage() {
    return global.location && global.location.pathname &&
      global.location.pathname.indexOf("/cart") === 0
  }

  function isCheckoutPage() {
    return global.location && global.location.pathname &&
      (global.location.pathname.indexOf("/checkouts/") === 0 ||
       global.location.pathname.indexOf("/checkout") === 0)
  }

  function updateCartNote(value, retries) {
    var noteValue = (value || "").trim();
    retries = retries || 0;
    var maxRetries = 3;
    var retryDelay = 500; // Start with 500ms delay

    return global.fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        note: noteValue,
        attributes: {
          delivery_date: noteValue,
        }
      })
    })
      .then(function (res) {
        if (!res.ok) {
          // Retry on 429 (rate limit) or 5xx errors
          if (retries < maxRetries && (res.status === 429 || res.status >= 500)) {
            var delay = retryDelay * Math.pow(2, retries); // Exponential backoff
            console.warn("[BinaeryCalendar] Cart note update failed, retrying in " + delay + "ms (attempt " + (retries + 1) + "/" + maxRetries + ")");
            return new Promise(function(resolve) {
              setTimeout(function() {
                resolve(updateCartNote(value, retries + 1));
              }, delay);
            });
          }
          throw new Error("Failed to update cart note: HTTP " + res.status);
        }
        return res.json();
      })
      .then(function (data) {
        // Verify the note was actually updated
        if (data && data.note !== undefined) {
          if (data.note !== noteValue) {
            console.warn("[BinaeryCalendar] Cart note mismatch. Expected: '" + noteValue + "', Got: '" + data.note + "'");
            // Retry once more if note doesn't match
            if (retries < maxRetries) {
              var delay = retryDelay * Math.pow(2, retries);
              return new Promise(function(resolve) {
                setTimeout(function() {
                  resolve(updateCartNote(value, retries + 1));
                }, delay);
              });
            }
          } else {
            console.log("[BinaeryCalendar] Cart note updated successfully: " + noteValue);
          }
        }
        return data;
      })
      .catch(function (e) {
        console.error("[BinaeryCalendar] Cart note update failed after " + (retries + 1) + " attempts:", e);

        // Show user-friendly error message
        if (retries >= maxRetries) {
          toast("Failed to save delivery date. Please try again or refresh the page.");
        }

        // Re-throw to allow caller to handle
        throw e;
      });
  }

  function toast(msg) {
    // TODO: replace with nice toast UI
    alert(msg);
  }

  function validateSelectedDateOnServer(cfg, selectedISO) {
    // Localized modification: validation is handled client side and rules come from Metafields.
    return Promise.resolve(true);
  }

  function bindHiddenInputs(value) {
    var propertyKey = "Delivery date";
    var forms = Array.prototype.slice.call(
      document.querySelectorAll("form[action*='/cart/add']")
    );

    forms.forEach(function (form) {
      var hidden = form.querySelector(
        'input[name="properties[' + propertyKey + ']"]'
      );
      if (!hidden) {
        hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "properties[" + propertyKey + "]";
        form.appendChild(hidden);
      }
      hidden.value = value || "";
    });
  }

  function setSelectedDeliveryDate(iso) {
    var cleanISO = (iso || "").trim();
    var formatted = isoToDDMMYYYY(cleanISO);

    //global.__BINAERY_DELIVERY_DATE_ISO__ = cleanISO;
    //global.__BINAERY_DELIVERY_DATE__ = formatted;

    if (isCartPage() || isCheckoutPage()) {
      // Wait for cart to be ready before updating note
      var updateNote = function() {
        updateCartNote(formatted)
          .then(() => {
            //console.log("[BinaeryCalendar] Cart note updated successfully");
            global.__BINAERY_DELIVERY_DATE_ISO__ = cleanISO;
            global.__BINAERY_DELIVERY_DATE__ = formatted;
            bindHiddenInputs(global.__BINAERY_DELIVERY_DATE__);
          })
          .catch(function(e) {
            // Error already logged and user notified in updateCartNote
            // Store the date anyway so it can be added via line item properties
            console.warn("[BinaeryCalendar] Note update failed, date will be added via line item properties");
          });
      };

      // Check if cart is loaded (some themes use cart.js or similar)
      if (typeof global.cart !== "undefined" && global.cart && typeof global.cart.ready === "function") {
        global.cart.ready(updateNote);
      } else {
        // Wait a bit for cart to initialize, then try
        setTimeout(updateNote, 100);
      }
      return;
    }
  }

  function ensureCartAddInterceptors() {
    if (global.__BINAERY_CART_INTERCEPTORS__) return;
    global.__BINAERY_CART_INTERCEPTORS__ = true;

    function getDeliveryDate() {
      return (global.__BINAERY_DELIVERY_DATE__ || "").trim();
    }

    function isCartAddUrl(url) {
      try {
        var u = new URL(url, global.location.origin);
        return (
          u.pathname === "/cart/add" ||
          u.pathname === "/cart/add.js" ||
          u.pathname.indexOf("/cart/add") === 0
        );
      } catch (e) {
        return typeof url === "string" && url.indexOf("/cart/add") !== -1;
      }
    }

    function ensurePropsInFormData(fd) {
      var v = getDeliveryDate();
      if (!v) return fd;

      if (fd.has("properties[Delivery date]")) return fd;

      fd.append("properties[Delivery date]", v);
      return fd;
    }

    function ensurePropsInJsonBody(json) {
      var v = getDeliveryDate();
      if (!v) return json;

      json = json || {};
      json.properties = json.properties || {};

      if (json.properties["Delivery date"]) return json;

      json.properties["Delivery date"] = v;
      return json;
    }

    var origFetch = global.fetch;
    if (typeof origFetch === "function") {
      global.fetch = function (input, init) {
        try {
          var url = typeof input === "string" ? input : (input && input.url) || "";
          var method = (init && init.method) || "GET";
          method = String(method || "GET").toUpperCase();

          if (method === "POST" && isCartAddUrl(url) && init) {
            var body = init.body;

            if (body && typeof FormData !== "undefined" && body instanceof FormData) {
              init.body = ensurePropsInFormData(body);
            }
            else if (body && typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
              var v = getDeliveryDate();
              if (v && !body.has("properties[Delivery date]")) {
                body.append("properties[Delivery date]", v);
              }
              init.body = body;
            }

            else if (typeof body === "string") {
              var looksJson = body.trim().charAt(0) === "{";
              if (looksJson) {
                try {
                  var parsed = JSON.parse(body);
                  parsed = ensurePropsInJsonBody(parsed);
                  init.body = JSON.stringify(parsed);

                  init.headers = init.headers || {};
                  if (!init.headers["Content-Type"] && !init.headers["content-type"]) {
                    init.headers["Content-Type"] = "application/json";
                  }
                } catch (e) {
                  // ignore
                }
              }
            }
          }
        } catch (e) {
          // never break add-to-cart
        }

        return origFetch.call(this, input, init);
      };
    }

    var OrigXHR = global.XMLHttpRequest;
    if (OrigXHR) {

      function PatchedXHR() {
        var xhr = new OrigXHR();
        var _open = xhr.open;
        var _send = xhr.send;
        var _url = "";
        var _method = "GET";

        xhr.open = function (method, url) {
          _method = String(method || "GET").toUpperCase();
          _url = url || "";
          return _open.apply(xhr, arguments);
        };

        xhr.send = function (body) {
          try {
            if (_method === "POST" && isCartAddUrl(_url)) {
              if (body && typeof FormData !== "undefined" && body instanceof FormData) {
                body = ensurePropsInFormData(body);
              } else if (typeof body === "string" && body.trim().charAt(0) === "{") {
                try {
                  var parsed = JSON.parse(body);
                  parsed = ensurePropsInJsonBody(parsed);
                  body = JSON.stringify(parsed);
                } catch (e) {}
              }
            }
          } catch (e) {}
          return _send.call(xhr, body);
        };

        return xhr;
      }

      global.XMLHttpRequest = PatchedXHR;
    }
  }

  ensureCartAddInterceptors();

  function isDateDisabled(date, state) {
    var iso = toISO(date);

    // ── Hard floor: past dates (and anything before minISO) are ALWAYS blocked.
    // This check must come before specialEnabledDates so that no past date
    // can ever be force-enabled, regardless of what is in specialEnabledDates.
    if (state.minISO && iso < state.minISO) return true;
    if (state.maxISO && iso > state.maxISO) return true;

    // Special Enabled Dates bypass the weekday / specific-date / range rules below.
    // They do NOT bypass the minISO/maxISO floor above.
    if (state.specialEnabledDates && state.specialEnabledDates.indexOf(iso) !== -1) {
      return false;
    }

    if (state.disabledWeekdays && state.disabledWeekdays.indexOf(date.getDay()) !== -1) {
      return true;
    }

    if (state.disabledDates && state.disabledDates.indexOf(iso) !== -1) {
      return true;
    }

    if (state.disabledRanges && state.disabledRanges.length) {
      for (var i = 0; i < state.disabledRanges.length; i++) {
        var r = state.disabledRanges[i];
        if (!r || !r.start || !r.end) continue;
        if (iso >= r.start && iso <= r.end) return true;
      }
    }
    return false;
  }

  function clampMonthToRange(date, state) {
    var d = new Date(date.getFullYear(), date.getMonth(), 1);

    if (state.minDate) {
      var minMonth = new Date(state.minDate.getFullYear(), state.minDate.getMonth(), 1);
      if (d < minMonth) return minMonth;
    }

    if (state.maxDate) {
      var maxMonth = new Date(state.maxDate.getFullYear(), state.maxDate.getMonth(), 1);
      if (d > maxMonth) return maxMonth;
    }

    return d;
  }

  function buildState(cfg, rules) {
    var disabledWeekdays = Array.isArray(rules.disabledWeekdays)
      ? rules.disabledWeekdays.slice()
      : [];

    var disabledDates = Array.isArray(rules.disabledDates)
      ? rules.disabledDates.map(function (d) { return String(d).slice(0, 10); })
      : [];

    var specialEnabledDates = Array.isArray(rules.specialEnabledDates)
      ? rules.specialEnabledDates.map(function (d) { return String(d).slice(0, 10); })
      : [];

    var disabledRanges = Array.isArray(rules.disabledRanges)
      ? rules.disabledRanges
          .map(function (r) {
            if (!r) return null;
            return {
              start: String(r.start || "").slice(0, 10),
              end: String(r.end || "").slice(0, 10),
            };
          })
          .filter(function (r) { return r && r.start && r.end; })
      : [];

    var minISO = rules.minDate ? String(rules.minDate).slice(0, 10) : null;
    var maxISO = rules.maxDate ? String(rules.maxDate).slice(0, 10) : null;

    // ── Cutoff / advance-days calculation ────────────────────────────────────
    // All time values come from Liquid (UK / Europe/London timezone) so they
    // are always correct regardless of the customer's device clock or locale.
    //
    // cutoffMode === "days":
    //   minDate = today + cutoffDays.
    //   If the current UK time has reached or passed cutoffTime, add one extra
    //   day (the merchant's "same-day cutoff" rule).
    //
    // cutoffMode === "none":
    //   Sunday is always the hard weekly cutoff boundary.
    //   The minimum selectable date is always pushed to the Monday of the
    //   following week (the day after the coming Sunday), ensuring customers
    //   can never pick dates within the current week.
    //   ukToday is enforced as an absolute floor so past dates are never selectable.

    var ukToday  = window.ukToday  || null;  // "YYYY-MM-DD"
    var ukHour   = window.ukHour   != null ? window.ukHour   : -1; // integer
    var ukMinute = window.ukMinute != null ? window.ukMinute : -1; // integer

    if (rules.cutoffMode === "days" && ukToday) {
      var cutoffDays = parseInt(rules.cutoffDays, 10) || 0;

      // Parse cutoffTime — expected format "HH:MM"
      var cutoffTimeParts = String(rules.cutoffTime || "00:00").split(":");
      var cutoffHour   = parseInt(cutoffTimeParts[0], 10) || 0;
      var cutoffMinute = parseInt(cutoffTimeParts[1], 10) || 0;

      // Has the daily cutoff time already passed right now in UK time?
      var cutoffPassed = (ukHour > cutoffHour) ||
                         (ukHour === cutoffHour && ukMinute >= cutoffMinute);

      // If cutoff has passed, one extra day is required
      var daysToAdd = cutoffPassed ? cutoffDays + 1 : cutoffDays;

      // Calculate the effective minimum date: today + daysToAdd
      var effectiveMinDate = parseYMD(ukToday);
      effectiveMinDate.setDate(effectiveMinDate.getDate() + daysToAdd);
      var effectiveMinISO = toISO(effectiveMinDate);

      // Use the later of: the metafield's static minDate vs the computed cutoff
      if (!minISO || minISO < effectiveMinISO) {
        minISO = effectiveMinISO;
      }
    } else {
      // cutoffMode === "none":
      // The coming Sunday is always the hard cutoff boundary.
      // If the customer is picking dates before that Sunday, the minimum
      // selectable date is moved to the Monday after that Sunday (next week).
      if (ukToday) {
        // Always enforce today (or tomorrow for Skio Portal) as an absolute floor first.
        var floorISO = ukToday;
        if (rules.isSkioPortal) {
          var todayDate = parseYMD(ukToday);
          var tomorrowDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate() + 1);
          floorISO = toISO(tomorrowDate);
        }

        if (!minISO || minISO < floorISO) {
          minISO = floorISO;
        }

        // In the Skio Portal, the customer is allowed to pick delivery dates within
        // the current week (triggering immediate payment capture). Thus, the Sunday weekly cutoff is bypassed.
        if (!rules.isSkioPortal) {
          // Find the number of days until the next Sunday (day 0).
          // If today IS Sunday (daysUntilSunday === 0), the cutoff is THIS Sunday,
          // so the next available week starts tomorrow (Monday).
          var todayDate = parseYMD(ukToday);
          var todayDow = todayDate.getDay(); // 0 = Sun, 1 = Mon, … 6 = Sat
          var daysUntilSunday = (7 - todayDow) % 7; // 0 if today is Sun, 1–6 otherwise

          // The cutoff Sunday (could be today if today is Sunday)
          var cutoffSunday = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate() + daysUntilSunday);

          // The first selectable day is the Monday right after that Sunday
          var mondayAfterSunday = new Date(cutoffSunday.getFullYear(), cutoffSunday.getMonth(), cutoffSunday.getDate() + 1);
          var sundayCutoffMinISO = toISO(mondayAfterSunday);

          // Use whichever is later: the already-computed minISO or the Sunday-derived floor
          if (!minISO || minISO < sundayCutoffMinISO) {
            minISO = sundayCutoffMinISO;
          }
        }
      }
    }

    var minDate = minISO ? parseYMD(minISO) : null;
    var maxDate = maxISO ? parseYMD(maxISO) : null;

    var today = new Date();
    var initialMonth = today;

    if (minDate && today < minDate) initialMonth = minDate;
    if (maxDate && today > maxDate) initialMonth = maxDate;

    var initialSelected = rules.currentDeliveryDate ? String(rules.currentDeliveryDate).slice(0, 10) : "";

    if (!initialSelected && global.__BINAERY_DELIVERY_DATE_ISO__) {
      initialSelected = String(global.__BINAERY_DELIVERY_DATE_ISO__).slice(0, 10);
    }

    return {
      cfg: cfg,
      specialEnabledDates: specialEnabledDates,
      disabledWeekdays: disabledWeekdays,
      disabledDates: disabledDates,
      disabledRanges: disabledRanges,
      minISO: minISO,
      maxISO: maxISO,
      minDate: minDate,
      maxDate: maxDate,
      selectedISO: initialSelected,
      currentMonth: clampMonthToRange(initialMonth, { minDate: minDate, maxDate: maxDate }),
    };
  }

  function renderCalendar(overlay, state) {
    var host = overlay.querySelector("[data-binaery-role='calendar-host']");
    var monthLabel = overlay.querySelector("[data-binaery-role='month-label']");
    var weekdayRow = overlay.querySelector("[data-binaery-role='weekday-row']");
    var dayGrid = overlay.querySelector("[data-binaery-role='day-grid']");
    if (!host || !monthLabel || !weekdayRow || !dayGrid) return;

    var monthNames = [
      "January","February","March","April","May","June",
      "July","August","September","October","November","December",
    ];

    var weekdayNames = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
    var firstDay = state.cfg.firstDay || 1;

    monthLabel.textContent =
      monthNames[state.currentMonth.getMonth()] + " " + state.currentMonth.getFullYear();

    var weekdayEls = weekdayRow.querySelectorAll(".binaery-calendar-weekday");
    for (var i = 0; i < weekdayEls.length; i++) {
      var idx = (firstDay + i) % 7;
      weekdayEls[i].textContent = weekdayNames[idx];
    }

    var year = state.currentMonth.getFullYear();
    var month = state.currentMonth.getMonth();
    var firstOfMonth = new Date(year, month, 1);
    var lastOfMonth = new Date(year, month + 1, 0);
    var daysInMonth = lastOfMonth.getDate();

    var firstDow = firstOfMonth.getDay();
    var offset = (firstDow - firstDay + 7) % 7;

    var today = new Date();
    var todayISO = toISO(new Date(today.getFullYear(), today.getMonth(), today.getDate()));

    var cells = dayGrid.querySelectorAll(".binaery-calendar-cell");
    for (var c = 0; c < cells.length; c++) {
      var cell = cells[c];

      cell.textContent = "";
      cell.disabled = false;
      cell.dataset.date = "";
      cell.classList.remove(
        "binaery-calendar-cell--empty",
        "binaery-calendar-cell--disabled",
        "binaery-calendar-cell--selected",
        "binaery-calendar-cell--today"
      );
      cell.onclick = null;

      var dayNumber = c - offset + 1;

      if (dayNumber < 1 || dayNumber > daysInMonth) {
        cell.classList.add("binaery-calendar-cell--empty");
        continue;
      }

      var dateObj = new Date(year, month, dayNumber);
      var iso = toISO(dateObj);

      var disabled = isDateDisabled(dateObj, state);
      var isSelected = state.selectedISO === iso;

      cell.textContent = String(dayNumber);
      cell.dataset.date = iso;

      if (disabled) {
        cell.disabled = true;
        cell.classList.add("binaery-calendar-cell--disabled");
      } else {
        if (isSelected) cell.classList.add("binaery-calendar-cell--selected");

        cell.onclick = (function (isoCopy) {
          return function () {
            state.selectedISO = isoCopy;
            host.dataset.selectedIso = isoCopy;
            renderCalendar(overlay, state);
          };
        })(iso);
      }

      if (iso === todayISO) {
        cell.classList.add("binaery-calendar-cell--today");
      }
    }
  }

  function attachHandlers(overlay, state) {
    var prevBtn   = overlay.querySelector("[data-binaery-role='prev']");
    var nextBtn   = overlay.querySelector("[data-binaery-role='next']");
    var closeBtn  = overlay.querySelector("[data-binaery-role='close']");
    var cancelBtn = overlay.querySelector("[data-binaery-role='cancel']");
    var saveBtn   = overlay.querySelector("[data-binaery-role='save']");
    var host      = overlay.querySelector("[data-binaery-role='calendar-host']");

    function close() {
      overlay.style.display = "none";
      if (document.body.contains(overlay)) document.body.removeChild(overlay);
    }

    if (prevBtn) prevBtn.onclick = function () {
      var prev = new Date(state.currentMonth.getFullYear(), state.currentMonth.getMonth() - 1, 1);
      state.currentMonth = clampMonthToRange(prev, state);
      renderCalendar(overlay, state);
    };

    if (nextBtn) nextBtn.onclick = function () {
      var next = new Date(state.currentMonth.getFullYear(), state.currentMonth.getMonth() + 1, 1);
      state.currentMonth = clampMonthToRange(next, state);
      renderCalendar(overlay, state);
    };

    if (closeBtn) closeBtn.onclick = close;
    if (cancelBtn) cancelBtn.onclick = close;

    if (saveBtn) {
      saveBtn.onclick = function () {
        var selectedISO = host.dataset.selectedIso || state.selectedISO || "";
        if (!selectedISO) {
          toast("Please select a date.");
          return;
        }

        saveBtn.disabled = true;
        validateSelectedDateOnServer(state.cfg, selectedISO)
          .then(function (isValid) {
            if (!isValid) {
              toast("Selected date is no longer available. Please choose another date.");
              return;
            }

            global.BinaeryCalendar.setSelectedDeliveryDate(selectedISO);
            close();
          })
          .catch(function () {
            toast("Unable to validate selected date. Please try again.");
          })
          .finally(function () {
            saveBtn.disabled = false;
          });
      };
    }

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) close();
    });
  }

  function initOverlay(overlay, cfg, rules) {
    var state = buildState(cfg, rules || {});
    renderCalendar(overlay, state);
    attachHandlers(overlay, state);
  }

  global.BinaeryCalendar = {
    initOverlay: initOverlay,
    setSelectedDeliveryDate: setSelectedDeliveryDate,
  };
})(window);


/* ---- Binaery storefront bootstrap ---- */
(function () {
  if (window.__BINAERY_STOREFRONT_LOADED__) return;
  window.__BINAERY_STOREFRONT_LOADED__ = true;

  var CALENDAR_HTML = `
<div class="binaery-overlay" data-binaery-role="overlay">
  <div class="binaery-modal">
    <button
      type="button"
      class="binaery-modal-close"
      data-binaery-role="close"
      aria-label="Close"
    >
      &times;
    </button>
    <div class="binaery-modal-body">
      <div
        class="binaery-modal-calendar"
        data-binaery-role="calendar-host"
      >
        <div class="binaery-calendar">
          <div class="binaery-calendar-header">
            <button
              type="button"
              class="binaery-calendar-nav"
              data-binaery-role="prev"
            >
              ‹
            </button>
            <div
              class="binaery-calendar-month"
              data-binaery-role="month-label"
            ></div>
            <button
              type="button"
              class="binaery-calendar-nav"
              data-binaery-role="next"
            >
              ›
            </button>
          </div>
          <div
            class="binaery-calendar-weekdays"
            data-binaery-role="weekday-row"
          >
            <div class="binaery-calendar-weekday"></div>
            <div class="binaery-calendar-weekday"></div>
            <div class="binaery-calendar-weekday"></div>
            <div class="binaery-calendar-weekday"></div>
            <div class="binaery-calendar-weekday"></div>
            <div class="binaery-calendar-weekday"></div>
            <div class="binaery-calendar-weekday"></div>
          </div>
          <div class="binaery-calendar-grid" data-binaery-role="day-grid">
            <button type="button" class="binaery-calendar-cell" data-day-index="0"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="1"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="2"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="3"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="4"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="5"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="6"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="7"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="8"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="9"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="10"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="11"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="12"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="13"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="14"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="15"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="16"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="17"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="18"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="19"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="20"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="21"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="22"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="23"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="24"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="25"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="26"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="27"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="28"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="29"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="30"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="31"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="32"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="33"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="34"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="35"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="36"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="37"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="38"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="39"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="40"></button>
            <button type="button" class="binaery-calendar-cell" data-day-index="41"></button>
          </div>
        </div>
      </div>
      <div class="binaery-modal-actions">
        <button
          type="button"
          class="binaery-ddp-btn"
          data-binaery-role="cancel"
        >
          Cancel
        </button>
        <button
          type="button"
          class="binaery-ddp-btn binaery-ddp-btn--primary"
          data-binaery-role="save"
        >
          Save date
        </button>
      </div>
    </div>
  </div>
</div>
`;

  function readConfig() {
    var el = document.getElementById("binaery-portal-config");
    if (!el) return null;

    return {
      firstDay: parseInt(
        el.dataset.firstDay || el.dataset.first_day || "1",
        10
      )
    };
  }

  async function loadRules(cfg) {
    // Localized modification: read rules from Shopify Metafield globally injected object
    if (window.BinaeryRulesData) {
      return window.BinaeryRulesData;
    }
    
    // Fallback if the Metafields are not setup
    return {
      "disabledWeekdays": [0, 1, 2, 6],
      "disabledDates": [],
      "disabledRanges": []
    };
  }

  var templatePromise = null;
  function loadTemplate() {
    if (templatePromise) return templatePromise;
    templatePromise = Promise.resolve().then(function () {
        var wrap = document.createElement("div");
        wrap.innerHTML = CALENDAR_HTML.trim();
        var overlay = wrap.querySelector("[data-binaery-role='overlay']");
        if (!overlay) throw new Error("Calendar template missing overlay root");
        return overlay;
      });
    return templatePromise;
  }

  function toast(msg) {
    alert(msg);
  }

  function openCalendar(cfg) {
    if (
      !window.BinaeryCalendar ||
      typeof window.BinaeryCalendar.initOverlay !== "function"
    ) {
      console.error("BinaeryCalendar.initOverlay not available");
      toast("Calendar script not loaded");
      return;
    }

    var overlayRef = null;

    loadTemplate()
      .then(function (overlayTpl) {
        overlayRef = overlayTpl.cloneNode(true);
        document.body.appendChild(overlayRef);
        overlayRef.style.display = "flex";

        var host = overlayRef.querySelector("[data-binaery-role='calendar-host']");
        if (host) {
          var skeleton = document.createElement("div");
          skeleton.className = "binaery-calendar-skeleton";
          skeleton.innerHTML =
            '<div class="binaery-calendar-skeleton-inner">' +
            '<div class="binaery-calendar-skel-header"></div>' +
            '<div class="binaery-calendar-skel-rows"></div>' +
            "</div>";
          host.appendChild(skeleton);
          overlayRef.__binaerySkeleton = skeleton;
        }

        return loadRules(cfg);
      })
      .then(function (rules) {
        if (!overlayRef) return;

        var skel = overlayRef.__binaerySkeleton;
        if (skel && skel.parentNode) {
          skel.parentNode.removeChild(skel);
        }

        window.BinaeryCalendar.initOverlay(overlayRef, cfg, rules || {});
      })
      .catch(function (err) {
        console.error("Failed to open calendar", err);

        if (overlayRef) {
          var host = overlayRef.querySelector("[data-binaery-role='calendar-host']");
          if (host) {
            host.innerHTML =
              '<div class="binaery-calendar-error">Unable to load calendar. Please try again.</div>';
          }
        } else {
          toast("Unable to open calendar. Please try again.");
        }
      });
  }

  function ensureTriggerButton(host, cfg) {
    var btn =
      host.querySelector("[data-binaery-role='trigger']") ||
      host.querySelector("button");

    if (cfg.auto) {
      var keep = btn;
      host.innerHTML = "";
      if (keep) host.appendChild(keep);
      btn = keep;
    }

    if (!btn) {
      btn = document.createElement("button");
      btn.setAttribute("data-binaery-role", "trigger");
      host.appendChild(btn);
    }

    if (btn.tagName.toLowerCase() !== "button") {
      var newBtn = document.createElement("button");
      newBtn.innerHTML = btn.innerHTML;
      newBtn.setAttribute("data-binaery-role", "trigger");

      btn.parentNode.replaceChild(newBtn, btn);
      btn = newBtn;
    }

    btn.type = "button";

    if (!btn.className || !btn.className.trim()) {
      btn.className = "binaery-ddp-btn binaery-ddp-btn--primary";
    }

    if (!btn.__binaeryBound) {
      btn.__binaeryBound = true;
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        openCalendar(cfg);
      });
    }

    return btn;
  }

  function boot() {
    var cfg = readConfig();
    if (!cfg) return;

    var host = document.getElementById("binaery-portal-config");
    if (!host) return;

    ensureTriggerButton(host, cfg);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
